export default [

    // *--------- SECTOR ---------------------------------*
    {
        path: '/railway-structure/sector/list',
        name: 'railway_structure-sector-list',
        component: () => import('@/views/apps/railway_structure/sector/views/List.vue'),
        meta: {
            resource: 'sector',
            action: 'read',
            pageTitle: 'Участки',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Участки',
                  active: true,
                },

            ],
        },
    },
    {
        path: '/railway-structure/sector/view/:id',
        name: 'railway_structure-sector-view',
        component: () => import('@/views/apps/railway_structure/sector/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Участки',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Участки',
                    to: {
                        name: 'railway_structure-sector-list'
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
